module.exports = __webpack_public_path__ + "img/history.cead002d.jpg";